import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Edit } from "lucide-react";
import { FundAvatar } from "../components/FundAvatar";
import { Fund } from "@/types/Fund";

interface FundsTableProps {
  isLoading: boolean;
  filteredFunds: Fund[];
  onEditFund: (fund: Fund) => void;
}

export const FundsTable: React.FC<FundsTableProps> = ({
  isLoading,
  filteredFunds,
  onEditFund,
}) => {
  return (
    <div className="max-h-[80vh] overflow-auto">
      <Table>
        <TableHeader className="sticky top-0 bg-background z-10">
          <TableRow>
            <TableHead className="w-12"></TableHead>
            <TableHead>Key</TableHead>
            <TableHead>Name</TableHead>
            <TableHead className="w-24 text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell colSpan={4} className="text-center py-4">
                Loading funds...
              </TableCell>
            </TableRow>
          ) : filteredFunds.length > 0 ? (
            filteredFunds.map((fund: Fund) => (
              <TableRow key={fund.fundId}>
                <TableCell>
                  <FundAvatar
                    fundKey={fund.fundKey || fund.name.substring(0, 3)}
                    name={fund.name}
                    size="sm"
                  />
                </TableCell>
                <TableCell>{fund.fundKey || "-"}</TableCell>
                <TableCell className="font-medium">{fund.name}</TableCell>
                <TableCell className="text-right">
                  <div className="flex justify-end gap-2">
                    <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => onEditFund(fund)}
                    >
                      <Edit className="h-4 w-4" />
                      <span className="sr-only">Edit</span>
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={4} className="text-center py-4">
                No funds found matching your search.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};
